import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <DCSummaryBlock slots="heading, text" theme="lightest" btnVariant="cta" isBtnVariant className="pdfextractapi" mdxType="DCSummaryBlock" />
    <h2 {...{
      "id": "adobe-pdf-extract-api"
    }}>{`Adobe PDF Extract API`}</h2>
    <p>{`A new web service that allows you to unlock content structure and table data from any PDF document with machine learning.`}</p>
    <TextBlock slots="assetImg" theme="lightest" width="100%" imageOnly className="padding_top_align padding-zero imageHightAuto" mdxType="TextBlock" />
    <p>{`extract-img`}</p>
    <TextBlock slots="text" width="33%" theme="lightest" className="align-left padding-top-zero" mdxType="TextBlock" />
    <p>{`Leverage Adobe Sensei for a rich understanding of `}<strong parentName="p">{`content structure`}</strong>{` with higher quality input to other systems.`}</p>
    <TextBlock slots="text" width="33%" theme="lightest" className="align-left padding-top-zero" mdxType="TextBlock" />
    <p><strong parentName="p">{`Easily Extract content to JSON`}</strong>{` format for further processing into other applications or databases.`}</p>
    <TextBlock slots="text" width="33%" theme="lightest" className="align-left padding-top-zero" mdxType="TextBlock" />
    <p><strong parentName="p">{`Identify more document elements`}</strong>{` than OCR with extraction of headings, paragraphs, lists, and more.`}</p>
    <TextBlock slots="buttons" isCentered theme="lightest padding-top-zero why-doc-get-started-btn" className="Use-cases-for-PDF-services-API" mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract"
        }}>{`Learn more`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      